import { render } from "./YogaLayout.vue?vue&type=template&id=5a9c1f54"
import script from "./YogaLayout.vue?vue&type=script&lang=js"
export * from "./YogaLayout.vue?vue&type=script&lang=js"

import "./YogaLayout.vue?vue&type=style&index=0&id=5a9c1f54&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__